import React, { useState, useRef, useEffect } from 'react';
import './MyDropdownGeneric.css';

function MyDropdownGeneric({ label, options, error, style, width, onChange, value, ...props }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    setSearchTerm('');
    setIsOpen(false);
    if (onChange) {
      onChange(option);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  const filteredOptions = options.filter(option =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="dropdown-wrapper" ref={dropdownRef} style={style}>
      {label && <label className="dropdown-label">{label}</label>}
      <input
        className="dropdown-input"
        type="text"
        placeholder="Select an option"
        value={searchTerm || value}
        onChange={handleSearchChange}
        onClick={toggleDropdown}
        style={{ width: width || '90%' }}
        {...props}
      />
      {isOpen && (
        <ul className="dropdown-list">
          {filteredOptions.map((option, index) => (
            <li key={index} className="dropdown-item" onClick={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
      {error && <span className="error-text">{error}</span>}
    </div>
  );
}

export default MyDropdownGeneric;